import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../img/icons/Shield.png';
import _imports_1 from '../../img/icons/Van.png';
import _imports_2 from '../../img/icons/RefreshRight.png';
import _imports_3 from '../../img/icons/Headset.png';
import _imports_4 from '../../img/icons/QRCode.jpg';
const _withScopeId = n => (_pushScopeId("data-v-1ca31e36"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "site-footer"
};
const _hoisted_2 = {
  class: "service-bar"
};
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  alt: ""
};
const _hoisted_6 = {
  key: 3,
  src: _imports_3,
  alt: ""
};
const _hoisted_7 = {
  class: "service-text"
};
const _hoisted_8 = {
  key: 0,
  class: "service-title"
};
const _hoisted_9 = {
  key: 1,
  class: "service-title"
};
const _hoisted_10 = {
  key: 2,
  class: "service-desc"
};
const _hoisted_11 = {
  key: 3,
  class: "service-desc"
};
const _hoisted_12 = {
  class: "nav-section"
};
const _hoisted_13 = {
  class: "nav-container"
};
const _hoisted_14 = {
  style: {
    "display": "flex",
    "width": "800px",
    "justify-content": "space-between"
  }
};
const _hoisted_15 = {
  class: "nav-column"
};
const _hoisted_16 = {
  class: "nav-column"
};
const _hoisted_17 = {
  class: "nav-column"
};
const _hoisted_18 = {
  class: "nav-column"
};
const _hoisted_19 = {
  class: "nav-column contact-column"
};
const _hoisted_20 = {
  key: 0,
  class: "nav-title",
  style: {
    "width": "165px",
    "text-align": "center",
    "margin-bottom": "8px"
  }
};
const _hoisted_21 = {
  key: 1,
  class: "nav-title",
  style: {
    "width": "165px",
    "text-align": "center",
    "margin-bottom": "8px"
  }
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contact-phone"
}, "17020685084", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qrcode-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "QRcode",
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"copyright-section\" data-v-1ca31e36><div class=\"copyright-content\" data-v-1ca31e36><p class=\"address\" data-v-1ca31e36>地址：浙江省湖州市德清县长虹东街892号</p><p class=\"copyright\" data-v-1ca31e36>Copyright © 2024 浙江蓝德能源科技发展有限公司 All Rights Reserved.</p><p class=\"icp\" data-v-1ca31e36><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" data-v-1ca31e36>浙ICP备20023883号-1</a><span class=\"police-icon\" data-v-1ca31e36><a href=\"https://www.beian.gov.cn/\" target=\"_blank\" data-v-1ca31e36>浙公网安备33052102001041号</a></span></p></div></div>", 1);
import { ref, reactive, onMounted, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
// 服务栏数据

export default {
  __name: 'navigationbar',
  setup(__props) {
    const serviceList = [{
      id: 1,
      title: '品质保证',
      desc: '100%正品货源',
      titleOne: 'Quality Assurance',
      descOne: "100% Genuine Goods"
    }, {
      id: 2,
      title: '安全配送',
      desc: '专业化学品物流',
      titleOne: 'Safe delivery',
      descOne: "Professional Chemical Logistics"
    }, {
      id: 3,
      title: '售后物流',
      desc: '无忧退换货服务',
      titleOne: 'After-sales Logistics',
      descOne: "Worry-free Return And Exchange Service"
    }, {
      id: 4,
      title: '技术支持',
      desc: '专业团队在线解答',
      titleOne: 'Technical Support',
      descOne: "Professional Team Provides Online Answers"
    }];
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const switchShow = computed(() => store.state.switchShow);
    const tabBtn = index => {
      localStorage.setItem("headId", index);
      if (index == '0') {
        router.push({
          path: "/"
        });
      } else if (index == '1') {
        router.push({
          path: "/product"
        });
      } else if (index == '2') {
        router.push({
          path: "/service"
        });
      } else if (index == '3') {
        router.push({
          path: "/About"
        });
      } else if (index == '4') {
        router.push({
          path: "/shopping"
        });
      } else {
        router.push({
          path: "/medium"
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(serviceList, item => {
        return _createElementVNode("div", {
          class: "service-item",
          key: item.id
        }, [item.id == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true), item.id == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), item.id == 3 ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), item.id == 4 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.title), 1)) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.titleOne), 1)) : _createCommentVNode("", true), switchShow.value == true ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.desc), 1)) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.descOne), 1)) : _createCommentVNode("", true)])]);
      }), 64))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [switchShow.value == true ? (_openBlock(), _createElementBlock("h3", {
        key: 0,
        class: "nav-title",
        onClick: _cache[0] || (_cache[0] = $event => tabBtn('1'))
      }, "产品分类")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("h3", {
        key: 1,
        class: "nav-title",
        onClick: _cache[1] || (_cache[1] = $event => tabBtn('1'))
      }, "Product Category")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [switchShow.value == true ? (_openBlock(), _createElementBlock("h3", {
        key: 0,
        class: "nav-title",
        onClick: _cache[2] || (_cache[2] = $event => tabBtn('2'))
      }, "科研服务")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("h3", {
        key: 1,
        class: "nav-title",
        onClick: _cache[3] || (_cache[3] = $event => tabBtn('2'))
      }, "Research Services")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [switchShow.value == true ? (_openBlock(), _createElementBlock("h3", {
        key: 0,
        class: "nav-title",
        onClick: _cache[4] || (_cache[4] = $event => tabBtn('3'))
      }, "关于我们")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("h3", {
        key: 1,
        class: "nav-title",
        onClick: _cache[5] || (_cache[5] = $event => tabBtn('3'))
      }, "About Us")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_18, [switchShow.value == true ? (_openBlock(), _createElementBlock("h3", {
        key: 0,
        class: "nav-title",
        onClick: _cache[6] || (_cache[6] = $event => tabBtn('4'))
      }, "购物指南")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("h3", {
        key: 1,
        class: "nav-title",
        onClick: _cache[7] || (_cache[7] = $event => tabBtn('4'))
      }, "Shopping Guide")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_19, [switchShow.value == true ? (_openBlock(), _createElementBlock("h3", _hoisted_20, "客服咨询专线")) : _createCommentVNode("", true), switchShow.value == false ? (_openBlock(), _createElementBlock("h3", _hoisted_21, "Service Hotline")) : _createCommentVNode("", true), _hoisted_22, _hoisted_23])])]), _hoisted_24]);
    };
  }
};